import { render, staticRenderFns } from "./ProductListTable.vue?vue&type=template&id=6282504e&scoped=true&lang=html"
import script from "./ProductListTable.vue?vue&type=script&lang=js"
export * from "./ProductListTable.vue?vue&type=script&lang=js"
import style0 from "./ProductListTable.vue?vue&type=style&index=0&id=6282504e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6282504e",
  null
  
)

export default component.exports